import { PasswordValidator } from '@branchjs/tooling';
import React from 'react';
import type { PasswordCheckProps } from './PasswordCheck.types';

export function PasswordCheck(props: PasswordCheckProps) {
  const validator: PasswordValidator = props.validator || new PasswordValidator();
  const failedChecks = validator.explain(String(props.password));
  const validationLabels = validator.validationParams.map((rule) => {
    const currentRule = rule.title;
    return (
      <li key={rule.type} className="validation-li" data-testid={rule.type}>
        {!failedChecks.find((e) => {
          // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
          return e == currentRule;
        }) ? (
          <i className="material-icons valid">check</i>
        ) : (
          <i className="material-icons invalid">close</i>
        )}
        <span className={'validation-label'}>{rule.title}</span>
      </li>
    );
  });

  const key = 'password';
  if (props.errors[key]) {
    return props.errors[key];
  }

  if (props.password) {
    return (
      <ul className="validation-rules" data-testid="password-validations">
        {validationLabels}
      </ul>
    );
  }

  if (props.errorFootnotes[key]) {
    return '';
  }

  return (
    <div className="default-password-footer">
      Must contain a capital and lowercase letter, a number, a symbol, and min of 8 characters.
    </div>
  );
}
